import Cookies from 'js-cookie';
const app = {
  state: {
    aucRules: Cookies.getJSON('zy-saas-moile-web-aucRules'),
    shopId: Cookies.get('zy-saas-moile-web-shopId'),
    token: Cookies.get('zy-saas-moile-web-token'),
    userId: Cookies.get('zy-saas-moile-web-userId'),
    userPhone: Cookies.get('zy-saas-moile-web-userPhone') || null,
    source:null,
    qiniuToken: null,
    userinfos: null,
    userShopinfos: Cookies.get('userShopinfos'),
    hasOpenPay: false, // 是否开通了店铺
    multipleSelection: [],
    keepAlive: ['liveIndex'],
  },

  mutations: {
    setAucRules(state, data) {
      state.aucRules = data;
      Cookies.set('zy-saas-moile-web-aucRules', data);
    },
    setShopId(state, data) {
      state.shopId = data;
      Cookies.set('zy-saas-moile-web-shopId', data);
    },
    setUserId(state, data) {
      state.userId = data;
      Cookies.set('zy-saas-moile-web-userId', data);
    },
    setToken(state, data) {
      state.token = data;
      Cookies.set('zy-saas-moile-web-token', data);
    },
    setUserPhone(state, data) {
      state.userPhone = data;
      Cookies.set('zy-saas-moile-web-userPhone', data);
    },
    setQiniuToken(state, data) {
      state.qiniuToken = data;
    },
    setUserinfos(state, data) {
      state.userinfos = data;
    },
    setSource(state, data) {
      state.source = data;
    },
    setHasOpenPay(state, data) {
      state.hasOpenPay = data;
    },
  },

  actions: {
    setAucRules({ commit }, data) {
      commit('setAucRules', data);
    },
    setShopId({ commit }, data) {
      commit('setShopId', data);
    },
    setUserId({ commit }, data) {
      commit('setUserId', data);
    },
    setToken({ commit }, data) {
      commit('setToken', data);
    },
    setUserPhone({ commit }, data) {
      commit('setUserPhone', data);
    },
    setQiniuToken({ commit }, data) {
      commit('setQiniuToken', data);
    },
    setUserinfos({ commit }, data) {
      commit('setUserinfos', data);
    },
    setSource({ commit }, data) {
      commit('setSource', data);
    },
    setHasOpenPay({ commit }, data) {
      commit('setHasOpenPay', data);
    },
  },
};
export default app;
